import { createSlice } from '@reduxjs/toolkit'
import { ToastContainer, toast } from 'react-toastify';
import { ParseObject } from '../../components/ExistingQuotation';
import SalesDashboard from '../../components/SalesDashboard';

const customId = "custom-id";
const customId2 = "custom-id2";
const customId3 = "custom-id3";
const initialState = {
  sections: { currentActive: 1, sectionCount: 1 },
  cartItems:[],
  miscCantileverItems:[],
  user: {id: '', loggedIn: localStorage.getItem('user')},
  quotationItems: [{id: '', part: {}, quantity: 0, section: 1}],
  pickListQuotationParts: [],
  quotationNumber: '',
  revisionQuotation:{},
  selectedClient: null,
  quotationType: [], 
  quotationPercentageToWin: 50,
  revisionInProgress: false,
  quotationsData: [],
  salesDashboardData: [],
  selectedSalesPerson: '',
  salesPeople: [],
  quotationTypes: ['Cantilever Racks', 'Pallet Racks', 'Light Duty Shelving', 'Conveyors', 'Mezzanine Floors', 'Installation', 'Audit', 'Special Racking', 'Miscellaneous', 'Repair', 'Relocation', 'Dismantle', 'Push back racking', 'Drive in racking', 'A-frame racking'],
  quotationTypesShort: { 'Cantilever Racks': "canti", 'Pallet Racks': 'pallet', 'Light Duty Shelving': "LDutyShelv", 'Conveyors': "conv", 'Mezzanine Floors': "mezz", 'Installation': "install", 'Audit': "audit", 'Special Racking': "SRacking", 'Miscellaneous': "misc", 'Repair': 'rep', 'Relocation': 'reloc', 'Dismantle': 'disMan', 'Push back racking': 'PushBRack', 'Drive in racking': 'driveInRack', 'A-frame racking': 'AFrameRack' }
};

export const cartSlice = createSlice({
  name: "counter",
  initialState,
  reducers: {
    addToCart: (state, action) => {
      if (state.cartItems?.length >= 1) {
        state.sections.currentActive = action.payload.section;
        state.sections.sectionCount = Math.max(state.sections.sectionCount, action.payload.section);
        if (
          state.cartItems[0].part.get("finish") !==
            action.payload.part.get("finish") &&
          state.cartItems[0].section === state.sections.currentActive
        ) {
          if (action.payload.part.get("className") === 'CantileverParts') {
            toast.error("Adding contrary polished piece", {
              toastId: customId,
            });
          }
        }
        const baseExists = state.cartItems.find(
          (p) => p.part.get("name") === "Base"
        );
        const ArmExists = state.cartItems.find(
          (p) => p.part.get("name") === "Arm"
        );
        if (
          baseExists !== undefined &&
          action.payload.part.get("name") === "Arm" &&
          action.payload.part.get("depth") !==
            Object.values(baseExists)[1].get("armToSuitBase").replace(/ /g, "")
        ) {
          if (action.payload.part.get("className") === 'CantileverParts'){
            toast.error("Adding contrary Arm relative to already selected Base", {
            toastId: customId2,
          });
        }
        }
        if (
          ArmExists !== undefined &&
          action.payload.part.get("name") === "Base" &&
          action.payload.part.get("armToSuitBase").replace(/ /g, "") !==
            Object.values(ArmExists)[1].get("depth")
        ) {
          if (action.payload.part.get("className") === 'CantileverParts')
          {toast.error("Adding contrary Arm relative to already selected Base", {
            toastId: customId3,
          });}
        }
        const existingItem = state.cartItems.find(
          (item) =>
            item.id === action.payload.id &&
            item.section === state.sections.currentActive
        );
        if (existingItem) {
          console.log('existingItem: ',existingItem.section);
          existingItem.quantity = action.payload.quantity;
          existingItem.price = action.payload.price;
          existingItem.section = state.sections.currentActive;
          console.log('existingItem???????: ',existingItem.section);
        } else {
          state.cartItems.push(action.payload);
        }
      } else {
        state.cartItems = [...state.cartItems, action.payload];       
      }
    },
    updateCartItem: (state, action) => {
      const externalVendor = action.payload.externalVendor;
      const existingItem = state.cartItems.find(
        (item) => {
          return (item.id === action.payload.id && item.section === action.payload.section)
        }
      );
      if (existingItem) {
        existingItem.quantity = parseInt(action.payload.quantity);
        existingItem.price = existingItem.part.get("price") * parseInt(action.payload.quantity);
      }
      if (existingItem && externalVendor) {
        existingItem.price = action.payload.price;
        existingItem.quantity = parseInt(action.payload.quantity);
      }
    },
    removeFromCart: (state, action) => {
      console.log('>> ',action.payload);
      state.cartItems.forEach((item, index) => {
        if (item.id === action.payload.id && item.section === action.payload.section) {
          state.cartItems.splice(index, 1);
        }
      });
    },
    addAnotherSection: (state, action) => {
      state.sections.sectionCount++;
      state.sections.currentActive = state.sections.sectionCount;
    },
    deleteSection: (state, action) => {
    const deletedSection = action.payload;

    // Filter out and re-index sections
    const updatedCart = state.cartItems
      .filter((item) => item.section !== deletedSection)
      .map((item) => {
        if (item.section > deletedSection) {
          return { ...item, section: item.section - 1 }; // shift down
        }
        return item;
      });

    const updatedMiscCart = state.miscCantileverItems
      .filter((item) => item.section !== deletedSection)
      .map((item) => {
        if (item.section > deletedSection) {
          return { ...item, section: item.section - 1 };
        }
        return item;
      });

    // ✅ Update the state
    state.cartItems = updatedCart;
    state.miscCantileverItems = updatedMiscCart;

    // Decrease section count (but don’t go below 0)
    state.sections.sectionCount = Math.max(state.sections.sectionCount - 1, 0);

    // ✅ Handle edge cases for active section
    if (state.sections.sectionCount === 0) {
      // No sections left
      state.sections.currentActive = null;
    } else if (deletedSection > state.sections.sectionCount) {
      // Deleted the last section → move to new last
      state.sections.currentActive = state.sections.sectionCount;
    } else if (deletedSection > 1) {
      // Deleted a middle or later section → move to previous one
      state.sections.currentActive = deletedSection - 1;
    } else {
      // Deleted the first section → stay at 1
      state.sections.currentActive = 1;
    }
  },
    currentActiveSection: (state, action) => {
      state.sections.currentActive = action.payload;
    },
    addProfileInformation: (state, action) => {
      state.user.id = action.payload.id;
      state.user.loggedIn = action.payload.loggedIn;
    },
    emptyCart: (state, action) => {
      state.cartItems = [];
      state.miscCantileverItems = [];
    },
    initializeQuotationItems: (state, action) => {
      const stateCopy = Object.assign({}, state);
      stateCopy.quotationItems = action.payload;
      state.quotationItems = stateCopy.quotationItems;
    },
    addToMiscCartItems: (state, action) => {
      console.log(action);
      if (state.miscCantileverItems.length > 0) {
        const existingItem = state.miscCantileverItems.find(
          (item) =>
            item.id === action.payload.id &&
            state.miscCantileverItems[0].section ===
              state.sections.currentActive
        );
        if (existingItem) {
          existingItem.quantity = action.payload.quantity;
          existingItem.price = action.payload.price;
          existingItem.section = action.payload.section;
        } else {
          state.miscCantileverItems.push(action.payload);
        }
      } else {
        const stateCopy = Object.assign({}, state);
        stateCopy.miscCantileverItems.push(action.payload);
        state.miscCantileverItems = stateCopy.miscCantileverItems;
      }
    },
    updateMiscCartItems: (state, action) => {
      const stateCopy = Object.assign({}, state);
      stateCopy.miscCantileverItems = (action.payload);
      state.miscCantileverItems = stateCopy.miscCantileverItems;
    },
    deleteMiscCartItem: (state, action) => {
      const stateCopy = Object.assign({}, state);
      const filteredArray = stateCopy.miscCantileverItems.filter((item) => item.id !== action.payload.id);
      state.miscCantileverItems = filteredArray;
    },
    updatePickListQuotationParts: (state, action) => {
      state.pickListQuotationParts = action.payload;
    },
    patchQuotationNumber: (state, action) => {
      state.quotationNumber = action.payload;
    },
    setSelectedClient: (state, action) => {
      state.selectedClient = action.payload;
    },
    setRevisionInProgress: (state, action) => {
      state.revisionInProgress = action.payload;
    },
    setRevisionQuotation: (state, action) => {
      state.revisionQuotation = action.payload;
    },
    setSelectedQuotationType: (state, action) => {
      state.quotationType = action.payload;
    },
    setSelectedPercentageToWin: (state, action) => {
      state.quotationPercentageToWin = action.payload
    },
    resetState: (state, action) => {
      state.sections = { currentActive: 1, sectionCount: 1 };
      state.cartItems =[];
      state.miscCantileverItems =[];
      state.user = {id: '', loggedIn: localStorage.getItem('user')};
      state.quotationItems = [{id: '', part: {}, quantity: 0, section: 1}];
      state.pickListQuotationParts = [];
      state.quotationNumber = '';
      state.selectedClient = null;
      state.quotationType = [];
      state.quotationPercentageToWin = 50;
      state.revisionInProgress = false;
      state.revisionQuotation = null;
    },
    setQuotations: (state, action) => {
      state.quotationsData = action.payload
    },
    setSalesDashboardData: (state, action) => {
      state.salesDashboardData= action.payload
    },
    setSelectedSalesPerson: (state, action) => {
      state.selectedSalesPerson= action.payload
    }, 
    setSalesPeople: (state,action) => {
      state.salesPeople= action.payload
    },
    updateQuotationTypes: (state, action) => {
      const generateShortVersion = (type) => {
        // Custom mappings for special cases
        const customMappings = {
          'Cantilever Racks': 'canti',
          'Light Duty Shelving': 'LDutyShelv',
          'Special Racking': 'SRacking'
        };
    
        // If there's a custom mapping, use it
        if (customMappings[type]) {
          return customMappings[type];
        }
    
        // Handle "racking" patterns
        if (type.toLowerCase().includes('racking')) {
          return type
            .replace(/\s+racking$/i, 'Rack')
            .split(' ')
            .map(word => word.charAt(0).toUpperCase() + word.slice(1))
            .join('');
        }
    
        // For short words
        if (type.length <= 6) {
          return type.toLowerCase();
        }
    
        // General rules
        const words = type.split(' ');
        if (words.length === 1) {
          return type.slice(0, 5).toLowerCase();
        }
    
        return words
          .map((word, index) => {
            if (index === 0) {
              return word.slice(0, 4).toLowerCase();
            }
            return word.charAt(0).toUpperCase() + word.slice(1, 3).toLowerCase();
          })
          .join('');
      };
    
      // Get the new type from the action payload
      const newType = action.payload;
      
      // Add the new type to quotationTypes if it doesn't exist
      if (!state.quotationTypes.includes(newType)) {
        state.quotationTypes.push(newType);
      }
    
      // Generate and add the short version if it doesn't exist
      if (!state.quotationTypesShort[newType]) {
        state.quotationTypesShort[newType] = generateShortVersion(newType);
      }
    },
  },
});

// Action creators are generated for each case reducer function
export const { addToCart, removeFromCart, addAnotherSection, currentActiveSection, addProfileInformation, emptyCart, updateCartItem, initializeQuotationItems, addToMiscCartItems, deleteSection, updatePickListQuotationParts, updateMiscCartItems, deleteMiscCartItem, patchQuotationNumber, setSelectedClient, setSelectedQuotationType, resetState, setSelectedPercentageToWin, setRevisionInProgress, setRevisionQuotation, setQuotations, setSalesDashboardData, setSelectedSalesPerson, setSalesPeople, updateQuotationTypes } = cartSlice.actions

export default cartSlice.reducer